import loadable from '@loadable/component';

// 懒加载组件
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));
const HosItemQuery = loadable(() => import('./hosItemQuery/HosItemQuery'));
const ItemNewManagement = loadable(() => import('./itemNewManagement/ItemNewManagement'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ItemPriceRequestManagement'));
const ItemPriceRequestDetailModify = loadable(() => import('./itemPriceRequestManagement/itemPriceRequestDetailModify/ItemPriceRequestDetailModify'));
const ShortageManagement = loadable(() => import('./shortageManagement/ShortageManagement'));
const FactoryManagement = loadable(() => import('./factoryManagement/FactoryManagement'));
const XadyItemNewManagement = loadable(() => import('./xadyItemNewManagement/XadyItemNewManagement'));
const Xa9yItemNewManagement = loadable(() => import('./xa9yItemNewManagement/Xa9yItemNewManagement'));
const ZZRMItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ZZRMItemPriceRequestManagement'));

export default [
  {
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  },
  {
    path: '/HosItemQuery',
    component: HosItemQuery
  },
  {
    path: '/ItemNewManagement',
    component: ItemNewManagement
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    path: '/ItemPriceRequestManagement',
    component: ItemPriceRequestManagement
  },
  {
    path: '/ItemPriceRequestDetailModify',
    component: ItemPriceRequestDetailModify
  },
  {
    path: '/ShortageManagement',
    component: ShortageManagement
  },
  {
    path: '/FactoryManagement',
    component: FactoryManagement
  },
  {
    path: '/XadyItemNewManagement',
    component: XadyItemNewManagement
  },
  {
    path: '/Xa9yItemNewManagement',
    component: Xa9yItemNewManagement
  },
  {
    path: '/ZZRMItemPriceRequestManagement',
    component: ZZRMItemPriceRequestManagement
  }
];
